// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');
}
.button,
.header-button {
  display: flex;
  padding: 9px 12px 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  background-color: #414855;
  border: none;
  border-radius: 4px;
  color: #66d1ff !important;
  /* H3 */
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.button .open-in-new,
.header-button .open-in-new {
  width: 20px;
  height: 20px;
}
.button:hover,
.header-button:hover,
.button:active,
.header-button:active {
  background-color: #A0E2FF !important;
  color: #272931 !important;
}
.button:hover .open-in-new,
.header-button:hover .open-in-new,
.button:active .open-in-new,
.header-button:active .open-in-new {
  fill: #272931 !important;
}
@media screen and (max-width: 1315px) {
  .header-button {
    display: none;
  }
}
.logged-out-buttons {
  display: flex;
  gap: 16px;
}
@media screen and (max-width: 1316px) {
  .logged-out-buttons {
    display: none;
  }
}
.product-button {
  display: flex;
  padding: 3px 12px 9px 0px;
  gap: 8px;
  border-radius: 4px;
  background-color: #414855;
  color: #66d1ff;
  border: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.8px;
}
.create-account-button {
  display: flex;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: #66d1ff;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1), 0px 3px 14px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.07);
  color: #272931;
  border: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.create-account-button:hover {
  background-color: #A0E2FF !important;
}
`, "",{"version":3,"sources":["https:/fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap","webpack://./src/components/HeaderButton.less"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;ADCA;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kIAAA;ACCF;AA5BA;;EACE,aAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EA+BA,OAAO;EA7BP,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA+BF;AA9CA;;EAmBE,WAAA;EACA,YAAA;AA+BF;AA7BA;;;;EAEE,oCAAA;EACA,yBAAA;AAiCF;AApCA;;;;EAMI,wBAAA;AAoCJ;AA7BE;EAAA;IACE,aAAA;EAgCF;AACF;AA7BA;EACE,aAAA;EACA,SAAA;AA+BF;AA9BE;EAAA;IACE,aAAA;EAiCF;AACF;AA5BA;EACE,aAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AA8BF;AA1BA;EACE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,0HAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AA4BF;AAxBA;EACE,oCAAA;AA0BF","sourcesContent":["@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 300;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 400;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 600;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4n.ttf) format('truetype');\n}\n@font-face {\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-weight: 700;\n  font-stretch: normal;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/opensans/v43/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4n.ttf) format('truetype');\n}\n","@import \"../styles/scientia-colors.less\";\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');\n\n.button, .header-button {\n  display: flex;\n  padding: 9px 12px 9px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  background-color: @scientia-grey;\n  border: none;\n  border-radius: 4px;\n  color: @scientia-blue !important;\n  /* H3 */\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n\n\n.open-in-new {\n  width: 20px;\n  height: 20px;\n}\n&:hover,\n&:active {\n  background-color: @scientia-button-hover-blue !important;\n  color: @scientia-dark !important;\n  .open-in-new {\n    // background-color: @scientia-button-hover-blue !important;\n    fill: @scientia-dark !important;\n  }\n}\n}\n\n\n.header-button {\n  @media screen and (max-width: 1315px) {\n    display: none;\n  }\n}\n\n.logged-out-buttons {\n  display: flex;\n  gap: 16px;\n  @media screen and (max-width: 1316px) {\n    display: none;\n  }\n}\n\n\n\n.product-button {\n  display: flex;\n  padding: 3px 12px 9px 0px;\n  gap: 8px;\n  border-radius: 4px;\n  background-color: @scientia-grey;\n  color: @scientia-blue;\n  border: none;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.8px;\n}\n\n\n.create-account-button {\n  display: flex;\n  padding: 9px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 4px;\n  background: @scientia-blue;\n  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.10), 0px 3px 14px 0px rgba(0, 0, 0, 0.06), 0px 8px 10px 0px rgba(0, 0, 0, 0.07);\n  color: @scientia-dark;\n  border: none;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  \n}\n\n.create-account-button:hover {\n  background-color: @scientia-button-hover-blue !important;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
